<template>
    <div class="textarea-wrapper">
        <textarea :value="value" @input="update($event)"></textarea>
        <span v-if="field.maxwords"><span :class="{red:words>=field.maxwords}">{{words}}</span> / {{field.maxwords}} words</span>
        <span v-if="field.maxchars"><span :class="{red:chars>=field.maxchars}">{{chars}}</span> / {{field.maxchars}} characters</span>
    </div>
</template>

<script>
    export default {
        name: 'v-textarea-field',
        props:['value', 'field'],
        computed:{
            chars(){
                if(!this.value) return 0;
                return this.value.length
            },
            words(){
                if(!this.value) return 0;
                return this.value.trim().split(" ").length
            }
        },
        methods:{
            update(ev){
                this.$emit('input', ev.target.value)
            }
        }
    }
</script>

<style scoped lang="scss">
    .textarea-wrapper{
        textarea{
            max-width:calc(100% - 10px);
            min-width:calc(100% - 10px);
        }
        span.red{
            color:red;
        }
    }
</style>
